import { render, staticRenderFns } from "./GestorAlarmes.vue?vue&type=template&id=ff56aca8&scoped=true"
import script from "./GestorAlarmes.vue?vue&type=script&lang=js"
export * from "./GestorAlarmes.vue?vue&type=script&lang=js"
import style0 from "./GestorAlarmes.vue?vue&type=style&index=0&id=ff56aca8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff56aca8",
  null
  
)

export default component.exports